import * as React from 'react';
import {
  Edit,
  SimpleForm,
  BooleanInput,
  TextInput,
  RadioButtonGroupInput,
  DateInput,
  ImageInput,
  ImageField,
  SelectInput,
  required,
  useRecordContext
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles({
  inline: {
      display: 'inline-block',
      marginLeft: '1em',
      '&.first-child': {
          marginLeft: 0,
      },
  },
});

const PreviewImage = ({ record, source }) => {
  if (typeof (record) == "string") {
      record = {
          [source]: `${record}`
      }
  }
  return <ImageField record={record} source={source} />
}

const BannerEdit = (props) => {

  const [list, setList] = React.useState([]);
  const [type, setType] = React.useState();
  const [orderValue, setOrderValue] = React.useState(props.record?.priority);
  const classes = useStyles();
  const priority = [
    { id: 1, name: '1' },
    { id: 2, name: '2' },
    { id: 3, name: '3' },
    { id: 4, name: '4' },
    { id: 5, name: '5' },
    { id: 6, name: '6' },
    { id: 7, name: '7' },
    { id: 8, name: '8' },
    { id: 9, name: '9' },
    { id: 10, name: '10' },
    { id: 11, name: '11' },
    { id: 12, name: '12' },
    { id: 13, name: '13' },
    { id: 14, name: '14' },
    { id: 15, name: '15' },
  ];

  React.useEffect(() => {
    const endpoint = type === 'VIDEO' ? 'lessons/all' : 'categories';
    fetch(`${process.env.REACT_APP_BASE_URL}/cms/${endpoint}`)
      .then(res => res.json())
      .then(data => setList(data))
  }, [type]);
  
  const dateFormatter = v => {
    const dateRegex = /^\d{4}-\d{2}-\d{2}/;
    if (dateRegex.test(v)) {
      return `${v}`.slice(0, 10)
    }
    
    return null;
  };

  const CustomPrioritySelector = () => {
    const data = useRecordContext()

    const defaultValue = data.priority ? data.priority : null

    return (
      <SelectInput
          source="priority"
          label="Prioridade"
          choices={priority}
          defaultValue={defaultValue}
        />
    )
  };

  const CustomRadioButton = () => {
    const thisrecord = useRecordContext()
    if (list.length < 1) {
      const endpoint = thisrecord.type === 'VIDEO' ? 'lessons/all' : 'categories';
      fetch(`${process.env.REACT_APP_BASE_URL}/cms/${endpoint}`)
      .then(res => res.json())
      .then(data => setList(data))
    }
    return (
      <RadioButtonGroupInput
          source="type"
          label="Tipo"
          validate={required()}
          defaultValue={thisrecord.type}
          onChange={(value) => setType(value)}
          choices={[
            { id: 'VIDEO', name: 'Video' },
            { id: 'CATEGORY', name: 'Categoria' },
          ]}
        />
    )
  }

  return (
    <Edit title="Edit Banner" {...props} >
      <SimpleForm>
        <BooleanInput label="Ativo" source="active" />
        <TextInput label="Nome" source="name" disabled={true} />

        <TextInput label="Nome (pt-BR)" source="ptbr_name" validate={required()} formClassName={clsx(classes.inline, 'first-child')} />
        <TextInput label="Nome (en-US)" source="enus_name" validate={required()} formClassName={classes.inline} />
        <TextInput label="Nome (es-ES)" source="es_name" validate={required()} formClassName={classes.inline} />
        {/* <TextInput label="Nome (hu-HU)" source="hu_name" validate={required()} formClassName={classes.inline} /> */}
        <div></div>
        <TextInput label="Subtítulo (pt-BR)" source="ptbr_sub" validate={required()} formClassName={clsx(classes.inline, 'first-child')} />
        <TextInput label="Subtítulo (en-US)" source="enus_sub" validate={required()} formClassName={classes.inline} />
        <TextInput label="Subtítulo (es-ES)" source="es_sub" validate={required()} formClassName={classes.inline} />
        {/* <TextInput label="Subtítulo (hu-HU)" source="hu_sub" validate={required()} formClassName={classes.inline} /> */}
        <div></div>
        <TextInput label="Descrição (pt-BR)" source="ptbr_desc" validate={required()} formClassName={clsx(classes.inline, 'first-child')} />
        <TextInput label="Descrição (en-US)" source="enus_desc" validate={required()} formClassName={classes.inline} />
        <TextInput label="Descrição (es-ES)" source="es_desc" validate={required()} formClassName={classes.inline} />
        {/* <TextInput label="Descrição (hu-HU)" source="hu_desc" validate={required()} formClassName={classes.inline} /> */}

        <CustomRadioButton />
        <SelectInput source="target_id" label="Destino" choices={list} validate={required()} />
        <CustomPrioritySelector />

        <DateInput label="Data de ínicio" source="date_start" format={dateFormatter} formClassName={clsx(classes.inline, 'first-child')} />
        <DateInput label="Date de término" source="date_end" format={dateFormatter} formClassName={classes.inline} />
        <ImageInput label="Banner" source="image" validate={required()}>
          <PreviewImage source="src" />
        </ImageInput>
      </SimpleForm>
    </Edit>
  );
}

export default BannerEdit;
